import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Card, TextField, Button, Typography, Alert, Link, IconButton, Tooltip, FormControlLabel, Checkbox } from '@mui/material';
import TranslateIcon from '@mui/icons-material/Translate';
import { login } from '../utils/api';
import { setJwtToken, isLoggedIn } from '../utils/auth';
import { useI18n } from '../utils/i18n';

export default function LoginPage() {
  const navigate = useNavigate();
  const { t, lang, toggleLang } = useI18n();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [trusted, setTrusted] = useState(true);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (isLoggedIn()) { navigate('/dashboard', { replace: true }); return null; }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await login(email, password, trusted);
      setJwtToken(data.token);
      navigate('/dashboard');
    } catch (err) { setError(err.message || 'Login failed'); }
    finally { setLoading(false); }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'background.default' }}>
      <Card sx={{ p: { xs: 3, sm: 4 }, width: { xs: '90%', sm: 380 }, maxWidth: 380, position: 'relative' }}>
        <Tooltip title={lang === 'en' ? '切换中文' : 'Switch to English'}>
          <IconButton size="small" onClick={toggleLang} sx={{ position: 'absolute', top: 12, right: 12, color: 'text.secondary' }}>
            <TranslateIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Typography variant="h5" color="primary" gutterBottom>{t('login.title')}</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>{t('login.subtitle')}</Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <form onSubmit={handleSubmit}>
          <TextField label={t('login.email')} fullWidth size="small" sx={{ mb: 2 }}
            value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" />
          <TextField label={t('login.password')} type="password" fullWidth size="small" sx={{ mb: 1 }}
            value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" />
          <FormControlLabel
            sx={{ mb: 2, ml: 0 }}
            control={<Checkbox size="small" checked={trusted} onChange={(e) => setTrusted(e.target.checked)} />}
            label={<Typography variant="body2" color="text.secondary">{t('login.trustDevice')}</Typography>}
          />
          <Button type="submit" variant="contained" fullWidth disabled={loading}>
            {loading ? t('login.loading') : t('login.submit')}
          </Button>
        </form>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2, textAlign: 'center' }}>
          {lang === 'zh'
            ? '暂不开放注册，如需开通请联系 '
            : 'Registration is paused. For access, contact '}
          <Link href="mailto:soraneyamasaki@gmail.com" color="primary">soraneyamasaki@gmail.com</Link>
        </Typography>
        <Button
          variant="text"
          fullWidth
          size="small"
          onClick={() => navigate('/dashboard')}
          sx={{ mt: 1, color: 'text.secondary', textTransform: 'none' }}
        >
          {t('login.continueAsGuest') || 'Continue as guest (limited access)'}
        </Button>
      </Card>
    </Box>
  );
}
